/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./styled.compiled.css";
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import * as colors from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ManualRuleEmptyState = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_p12fp59q", __cmplp.className])
  }));
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
if (process.env.NODE_ENV !== 'production') {
  ManualRuleEmptyState.displayName = 'ManualRuleEmptyState';
}
export const Message = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_zg8l4jg8 _k48p1nn1 _1wybdlk8 _vwz4gktf _1e0c1txw _4cvr1h6o _y3gn1h6o _18s8g97w _syaz1ddj", __cmplp.className])
  }));
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
if (process.env.NODE_ENV !== 'production') {
  Message.displayName = 'Message';
}
export const Links = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_18u01b66 _19pk1mwd _1bah1h6o _1e0c11p5 _y3gn1h6o", __cmplp.className])
  }));
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
if (process.env.NODE_ENV !== 'production') {
  Links.displayName = 'Links';
}
export const ActionLink = forwardRef(({
  as: C = "span",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_18s81wmz", __cmplp.className])
  }));
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
if (process.env.NODE_ENV !== 'production') {
  ActionLink.displayName = 'ActionLink';
}
export const EmptyStateIconContainer = forwardRef(({
  as: C = "div",
  style: __cmpls,
  ...__cmplp
}, __cmplr) => {
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_4t3ipo3b _1bsb1mjv _18s8v47k", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  EmptyStateIconContainer.displayName = 'EmptyStateIconContainer';
}